import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79c9e730"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "header" }
const _hoisted_2 = { id: "selectSearchContainer" }
const _hoisted_3 = { id: "inputSearchContainer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "menuContainer" }, "查询职业", -1))
const _hoisted_5 = { id: "IncludingColleges" }
const _hoisted_6 = { class: "collegesLine1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "collegesLine2" }

import {ref, reactive, onMounted, nextTick, onDeactivated, onActivated} from 'vue'
  import {ElMessage} from 'element-plus';
  import {useStore} from "@/store";
  import {Search} from '@element-plus/icons-vue'
  import {
    getCollegeInfoByInput,
    getCollegeInfoBySelect,
    getCollegeInfoBySelect2,
    getIndustryList,
    getOccList,
    getOccTypeByIndustry,
    getSelectSerachCity,
    getSelectSerachProvince,
    searchGetAllColleges,
    searchGetColleges
  } from "@/network/axios";
  import router from "@/router";

  
  const __default__ = {
    name: 'MobileFirstPage',
  }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  let store = useStore();

  //固定手机端的屏幕高度，（出键盘会把屏幕挤扁）
  let screenHeight = ref('');

  let professionSearchInfo: any = reactive({







    occName: '',
    industry: '',
    industryArray: [],
    occType: '',
    occTypeArray: [],
    professionArray: [],
  });

  //无限滚动
  let overNum = ref(30);
  let getProfessionArray = () => {
    if (overNum.value < professionSearchInfo.professionArray.length) {
      overNum.value += 15
    }
  }

  //获取 mainBody滚动条 id
  let mainBodyScrollBar = ref();

  //刚进页面 获取 头部第一个下拉框的值
  getIndustryList('/getIndustryList').then((res) => {
    professionSearchInfo.industryArray = [];
    professionSearchInfo.industryArray = res.data.data
  });

  //第一个下拉框有变动 获取第二个下拉框的值
  let select1Change = (val: any) => {
    professionSearchInfo.occType ='';
    getOccTypeByIndustry('/getOccTypeByIndustry', {
      params: {
        industry: val
      }
    }).then((res) => {
      professionSearchInfo.occTypeArray = [];
      professionSearchInfo.occTypeArray = res.data.data;
    })
    pageChange()
  };

  let select2Change =()=>{
    pageChange()
  }

  let pageChange =()=>{
    nextTick(() => {
      mainBodyScrollBar.value.scrollTop = 0;
    })
    getOccList('/getOccList', {
      params: {
        industry: professionSearchInfo.industry,
        occType: professionSearchInfo.occType,
        occName: professionSearchInfo.occName,
      }
    }).then((res) => {
      professionSearchInfo.professionArray = [];
      professionSearchInfo.professionArray = res.data.data;
    })
  }

  pageChange()

  //==========点击 跳转 页面================//
  let goMajorSituation = (occId:any) => {

    router.push('/MobileProfessionPage/' + occId)
  };


  let goTransferPage = () => {
    router.push('/MobileTransferPage/0101')
  };

  let goMajorSearch = () => {
    router.push('/MobileMajorSearch')
  };

  let goCollegeSearch = () => {
    router.push('/MobileFirstPage')
  };


  onMounted(() => {
    let FirstPageBackground = document.getElementById('FirstPageBackground') as HTMLElement;
    let height = FirstPageBackground.offsetHeight;
    screenHeight.value = height + 'px';
  });

  //缓存组件 离开页面前
  onDeactivated(() => {
    store.mobileFirstPageScrollTop = mainBodyScrollBar.value.scrollTop;
  });
  //缓存组件 被激活时
  onActivated(() => {
    mainBodyScrollBar.value.scrollTop = store.mobileFirstPageScrollTop
  });


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock("div", {
    id: "FirstPageBackground",
    style: _normalizeStyle({height:_unref(screenHeight)})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          id: "majorsInquireBtn",
          onClick: _unref(goTransferPage)
        }, {
          default: _withCtx(() => [
            _createTextVNode("专业查询")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          id: "selectSearchButton",
          type: "primary",
          onClick: _unref(goMajorSearch)
        }, {
          default: _withCtx(() => [
            _createTextVNode("专业搜索")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          style: {"width":"70px"},
          type: "primary",
          class: "deepBlueBtn",
          onClick: _unref(goCollegeSearch)
        }, {
          default: _withCtx(() => [
            _createTextVNode("院校查询")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: _unref(professionSearchInfo).occName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(professionSearchInfo).occName) = $event)),
          style: {"width":"100%"},
          placeholder: "职业名称",
          class: "elInput",
          clearable: "",
          onClear: _unref(pageChange)
        }, {
          prepend: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _unref(professionSearchInfo).industry,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(professionSearchInfo).industry) = $event)),
              class: "selectIndustryClass",
              clearable: "",
              onClear: _unref(pageChange),
              style: {"width":"95px","margin-right":"20px"},
              onChange: _unref(select1Change),
              placeholder: "行业",
              "popper-class": "elPopperSelect"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(professionSearchInfo).industryArray, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: item,
                    label: item
                  }, null, 8, ["value", "label"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue", "onClear", "onChange"]),
            _createVNode(_component_el_select, {
              modelValue: _unref(professionSearchInfo).occType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(professionSearchInfo).occType) = $event)),
              class: "selectOccTypeClass",
              clearable: "",
              onClear: _unref(pageChange),
              style: {"width":"95px"},
              onChange: _unref(select2Change),
              placeholder: "职业",
              "popper-class": "elPopperSelect"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(professionSearchInfo).occTypeArray, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: item,
                    label: item
                  }, null, 8, ["value", "label"]))
                }), 256))
              ]),
              _: 1
            }, 8, ["modelValue", "onClear", "onChange"])
          ]),
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _unref(pageChange),
              icon: _unref(Search)
            }, null, 8, ["onClick", "icon"])
          ]),
          _: 1
        }, 8, ["modelValue", "onClear"])
      ]),
      _hoisted_4
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      id: "mainBody",
      ref_key: "mainBodyScrollBar",
      ref: mainBodyScrollBar,
      "infinite-scroll-immediate": false
    }, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(professionSearchInfo).professionArray.slice(0,_unref(overNum)), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "collegesContainer",
            key: item.occId
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                onClick: ($event: any) => (_unref(goMajorSituation)(item.occId))
              }, _toDisplayString(item.occName), 9, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_row, { class: "collegesLine2Item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createTextVNode("行业：" + _toDisplayString(item.industry), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_row, { class: "collegesLine2Item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createTextVNode("职业类别：" + _toDisplayString(item.occType), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_row, { class: "collegesLine2Item" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createTextVNode("岗位薪资：" + _toDisplayString(item.positionSalary), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ])
          ]))
        }), 128))
      ])
    ])), [
      [_directive_infinite_scroll, _unref(getProfessionArray)]
    ])
  ], 4))
}
}

})